import React, { useEffect } from 'react';
import AppRoutes from './routes';
import i18n from './config/i18n';
import { I18nextProvider } from 'react-i18next';
import './styles/fonts.css';

function initializeLanguage() {
  const storedLanguage = sessionStorage.getItem('appLanguage'); // Busca no sessionStorage
  const browserLanguage = navigator.language.slice(0, 2); // Captura o idioma do navegador

  // Define o idioma com base no que estiver armazenado ou usa o do navegador
  const defaultLanguage = storedLanguage || (browserLanguage === 'pt' || browserLanguage === 'en' || browserLanguage === 'es' ? browserLanguage : 'pt');
  
  i18n.changeLanguage(defaultLanguage); // Configura o i18n com o idioma correto
  sessionStorage.setItem('appLanguage', defaultLanguage); // Salva no sessionStorage
}

const App: React.FC = () => {
  
  useEffect(() => {
    initializeLanguage(); // Inicializa a linguagem ao montar a aplicação
  }, []);
  
  return (
    <div>
        <I18nextProvider i18n={i18n}>
          <AppRoutes />
        </I18nextProvider>
    </div>
  );
};

export default App;
